export enum BidvTransferWithEvidenceQueryKeys {
  GET_TRANSFER_REQUEST_LIST = 'BIDV_EVIDENCE_GET_TRANSFER_REQUEST_LIST',
  GET_OWN_TRANSFER_REQUEST_LIST = 'BIDV_EVIDENCE_GET_OWN_TRANSFER_REQUEST_LIST',
  GET_TRANSFER_REQUEST_DETAIL = 'BIDV_EVIDENCE_GET_TRANSFER_REQUEST_DETAIL',
}
